import Vue from "vue"
import Vuex from "vuex"
import createPersistedState from 'vuex-persistedstate'
import code from '../assets/code.js'

Vue.use(Vuex);

console.log(code)

const store = new Vuex.Store({
  state: {
    identifyCode: '',
    //面包导航
    breadcrumb: [{
      name: '首页',
      path: '/'
    }],
    //操作员昵称
    nickName: '',
    AdminName: '',
    AdminType: '',
    AdminId: '', // cid
    Uid: '',
    isSys: '',
    permLevel: '',
    //token
    access_token: '',
    //当前激活菜单
    activeMenu: '',
    indexPath: '',
    //请求地址
    baseUrl: '',
    menuList: [],
    code: code,
    customerServiceNumber: ''
  },
  getters: {
    //监听操作员昵称
    getNickName: function (state) {
      return state.nickName
    },
  },
  mutations: {
    //改变验证码数据
    refreshNewCode(state, identifyCode) {
      state.identifyCode = identifyCode
    },
    //操作账户
    refreshNickName(state, nickName) {
      state.nickName = nickName
    },
    refreshAdminName(state, AdminName) {
      state.AdminName = AdminName
    },
    refreshAdminType(state, AdminType) {
      state.AdminType = AdminType
    },
    refreshAdminId(state, AdminId) {
      state.AdminId = AdminId
    },
    refreshAdminID(state, Uid) {
      state.Uid = Uid
    },
    refreshAdminIsSys(state, isSys) {
      state.isSys = isSys
    },
    refreshAdminPermLevel(state, permLevel) {
      state.permLevel = permLevel
    },
    //token
    refreshAccessToken(state, access_token) {
      state.access_token = access_token
    },
    refreshMenuList(state, menuList) {
      state.menuList = menuList
    },
    refreshIndexPath(state, indexPath) {
      state.indexPath = indexPath
    },
    refreshCustomerServiceNumber(state, customerServiceNumber) {
      state.customerServiceNumber = customerServiceNumber
    },
    
  },
  plugins: [createPersistedState({
    storage: window.sessionStorage
  })]
})

export default store